/**
 * Handly compiled list: https://lingohub.com/developers/supported-locales/language-designators-with-regions
 * Full list: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */var IsoLanguagesRegions = /*#__PURE__*/function (IsoLanguagesRegions) {
  /** Bulgarian */IsoLanguagesRegions["BG"] = "bg";
  /** Czech */
  IsoLanguagesRegions["CS"] = "cs";
  /** German */
  IsoLanguagesRegions["DE"] = "de";
  /** Greek */
  IsoLanguagesRegions["EL"] = "el";
  /** English */
  IsoLanguagesRegions["EN"] = "en";
  /** English (Austrailia) */
  IsoLanguagesRegions["EN_AU"] = "en-AU";
  /** English (Canada) */
  IsoLanguagesRegions["EN_CA"] = "en-CA";
  /** English (United Kingdom) */
  IsoLanguagesRegions["EN_GB"] = "en-GB";
  /** English (India) */
  IsoLanguagesRegions["EN_IN"] = "en-IN";
  /** English (New Zealand) */
  IsoLanguagesRegions["EN_NZ"] = "en-NZ";
  /** English (United States) */
  IsoLanguagesRegions["EN_US"] = "en-US";
  /** English (South Africa) */
  IsoLanguagesRegions["EN_ZA"] = "en-ZA";
  /** Spanish */
  IsoLanguagesRegions["ES"] = "es";
  /** Finnish */
  IsoLanguagesRegions["FI"] = "fi";
  /** French */
  IsoLanguagesRegions["FR"] = "fr";
  /** French (Canada) */
  IsoLanguagesRegions["FR_CA"] = "fr-CA";
  /** French (Switzerland) */
  IsoLanguagesRegions["FR_CH"] = "fr-CH";
  /** Hungarian */
  IsoLanguagesRegions["HU"] = "hu";
  /** Italian */
  IsoLanguagesRegions["IT"] = "it";
  /** Japanese */
  IsoLanguagesRegions["JA"] = "ja";
  /** Korean */
  IsoLanguagesRegions["KO"] = "ko";
  /** Norwegian Bokmål */
  IsoLanguagesRegions["NB"] = "nb";
  /** Dutch */
  IsoLanguagesRegions["NL"] = "nl";
  /** Dutch (Belgium) */
  IsoLanguagesRegions["NL_BE"] = "nl-BE";
  /** Polish */
  IsoLanguagesRegions["PL"] = "pl";
  /** Portuguese */
  IsoLanguagesRegions["PT"] = "pt";
  /** Romanian */
  IsoLanguagesRegions["RO"] = "ro";
  /** Russian */
  IsoLanguagesRegions["RU"] = "ru";
  /** Swedish */
  IsoLanguagesRegions["SV"] = "sv";
  /** Thai */
  IsoLanguagesRegions["TH"] = "th";
  /** Turkish */
  IsoLanguagesRegions["TR"] = "tr";
  /** Vietnamese */
  IsoLanguagesRegions["VI"] = "vi";
  /** Chinese */
  IsoLanguagesRegions["ZH"] = "zh";
  /** Chinese (China) */
  IsoLanguagesRegions["ZH_CN"] = "zh-cn";
  /** Chinese (Taiwan) */
  IsoLanguagesRegions["ZH_TW"] = "zh-tw"; // not currently used in BF
  return IsoLanguagesRegions;
}({});
export { IsoLanguagesRegions };